"use strict";
import largeStyles from "./src/scale-large.css.js";
import { Theme } from "./src/Theme.dev.js";
import "./core.dev.js";
Theme.registerThemeFragment("large", "scale", largeStyles);
//# sourceMappingURL=scale-large.dev.js.map
